<template>
    <ui-crud title="Vehicles" subtitle="Record keeping for vehicles, logs and maintenance." :fetch="fetch" :group-by="groupByStatus">

        <!-- Filters. -->
        <template #filters="{ debouncedRefresh }">
            <div class="relative">
                <ui-input class="mt-6" field="bg-gray-50 pr-10" name="search" v-model="search" @input="debouncedRefresh()"></ui-input>
                <div class="absolute right-0 inset-y-0 h-full flex items-center justify-center p-3 text-gray-400">
                    <i class="fas fa-search"></i>
                </div>
            </div>
        </template>

        <!-- List item. -->
        <template #list-item="{ item, select, active }">
            <ui-crud-card
                :title="`${item.make} ${item.model}`"
                :subtitle="item.driver_name"
                :metadata="item.vrn"
                :active="active"
                @click="select()"
                @keydown.enter="select()"
            ></ui-crud-card>
        </template>

        <!-- Create form. -->
        <template #create="{ addItem }">
            <assets-vehicles-form :add-item="addItem"></assets-vehicles-form>
        </template>

        <!-- Edit form. -->
        <template #edit="{ selectedItem, setEditMode }">
            <assets-vehicles-form :item="selectedItem" :edit="setEditMode"></assets-vehicles-form>
        </template>

        <!-- Show page. -->
        <template #show="{ selectedItem, setEditMode, removeItem }">
            <assets-vehicles-show :item="selectedItem" :edit="setEditMode" :removeItem="removeItem"></assets-vehicles-show>
        </template>
    </ui-crud>
</template>

<script>
import { Vehicle } from '@models'

export default {
    data () {
        return {
            search: '',
        }
    },
    methods: {
        groupByStatus (vehicle) {
            if(vehicle.is_current){
                return 'Current';
            }

            return 'Previous Vehicles';
        },
        async fetch () {
            return await Vehicle.search(this.search)
        },
    },
}
</script>
